import { render, staticRenderFns } from "./showpushform.vue?vue&type=template&id=943c5b72&scoped=true&"
import script from "./showpushform.vue?vue&type=script&lang=js&"
export * from "./showpushform.vue?vue&type=script&lang=js&"
import style0 from "./showpushform.vue?vue&type=style&index=0&id=943c5b72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943c5b72",
  null
  
)

export default component.exports